import { createRef, Component } from 'react';
import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

class _CompareCheckbox extends Component {
  constructor() {
    super();
    this.myRef = createRef();
  }

  componentDidMount() {
    const messageElement = this.myRef.current;

    if (messageElement) {
      const height = messageElement.clientHeight;

      messageElement.style.marginTop = `${-32 - height}px`;
    }
  }

  render() {
    const { card, label, labelsStore } = this.props;
    const disabled = card.compareDisabled ? 'disabled' : '';
    const checkboxID = `checkbox-compare-${card.skuID}`;

    return (
      <>
        <input
          type="checkbox"
          className="checkbox__input hidden add-comparator-checkbox"
          id={checkboxID}
          checked={card.isInComparator}
          readOnly
          data-product-id={card.skuID}
          data-da-element-id="compare"
          onClick={card.handleCompareClick}
        />

        <label htmlFor={checkboxID} className={`checkbox__label cart-table__checkbox ${disabled}`}>
          <PesIcon class="checkbox__icon" size={pesIconSizes.SMALL}>
            notification_ok
          </PesIcon>
          {label}
        </label>

        <span className="checkbox__full-comparator-msg js-full-comparator-msg" ref={this.myRef}>
          {labelsStore.maxAdded}
        </span>

        <span className="full-comparator-msg-arrow" />
      </>
    );
  }
}

_CompareCheckbox.propTypes = {
  card: propTypes.shape({
    skuID: propTypes.string,
    isInComparator: propTypes.bool,
    compareDisabled: propTypes.bool,
    handleCompareClick: propTypes.func
  }).isRequired,
  label: propTypes.string,
  labelsStore: propTypes.shape({
    max_added: propTypes.string
  }).isRequired
};

_CompareCheckbox.defaultProps = {
  label: ''
};

export const CompareCheckbox = inject((allStores) => ({
  labelsStore: allStores.labelsStore
}))(observer(_CompareCheckbox));
